import callApi from '../../utils/api';
import { ACTIVITY_ANALYSER } from '../../utils/constants';
import { parseParams } from '../../utils'

export const api = callApi(ACTIVITY_ANALYSER);

export const ACTIVITY_ANALYSER_ENDPOINTS = {
    emitActivity: '/v1/api/activities',
    getByCourseAndUser: '/v1/api/performance-report/users/{{userId}}/course/{{courseId}}',
    getReportsByUser: '/v1/api/performance-report/users/{{userId}}?{{query}}',
}

export const getReportsByUser = async ({ userId, query = {} }) => {
    const queryParams = new URLSearchParams(query).toString();

    return await api.get(parseParams(ACTIVITY_ANALYSER_ENDPOINTS.getReportsByUser, { userId, query: queryParams }));
}
